import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import buyAgainQuery from './query'
import { IBuyAgainVariables, IBuyAgainResponse } from './types'

/**
 * Hook declaration to obtain a lazy query of buy again products.
 * @param options: LazyQueryHookOptions
 * @internal
 */
const useLazyBuyAgain = (
  options?: LazyQueryHookOptions<IBuyAgainResponse, IBuyAgainVariables>,
) => {
  return useLazyQuery<IBuyAgainResponse, IBuyAgainVariables>(buyAgainQuery, {
    ...options,
    fetchPolicy: 'no-cache',
  })
}

export { useLazyBuyAgain }
